/* Generated from locales/en.json. */
export default {
  "actions.cancel": "Cancel",
  "actions.confirm": "Confirm",
  "actions.retry": "Try again",
  "actions.save": "Save",
  "app.name": "Hebrew Hearts",
  "auth.login": "Log in",
  "auth.register": "Create account",
  "auth.sessionExpired": "Session expired. Redirecting to login...",
  "errors.generic": "Something went wrong. Please try again.",
  "errors.network": "Network error. Check your connection and try again.",
  "navigation.account": "Account",
  "navigation.dashboard": "Dashboard",
  "navigation.matches": "Matches",
  "navigation.messages": "Messages",
  "navigation.profile": "Profile",
  "shell.loading": "Loading..."
};
